module.exports = __webpack_public_path__ + "static/media/MoveIcon.7a137b8b.svg";